module.exports = __webpack_public_path__ + "static/media/35.e518e6bf.jpg";